/**
 * When sticky product bar is enabled, personalization exists twice (main step + sticky bar).
 * Values stay mirrored on input/change. Only inputs with a real `name` submit with the product form.
 * Desktop (md+): both areas stay editable; sticky twins have `name` removed (backup in data-perso-line-item-name)
 * so line item properties are not duplicated. Typing in either field updates the other.
 * Mobile: sticky block is hidden; sticky inputs are disabled so only main submits.
 */
(function () {
  'use strict';

  const MQ = '(min-width: 768px)';
  const DATA_LINE_ITEM_NAME = 'persoLineItemName';

  function qsa(root, sel) {
    if (!root) {
      return [];
    }
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function lineItemPropertyName(el) {
    return el.getAttribute('name') || el.dataset[DATA_LINE_ITEM_NAME] || '';
  }

  function findByLineItemName(container, name) {
    if (!name) {
      return null;
    }
    for (const el of qsa(container, 'input.product-personalization__input-field')) {
      if (el.getAttribute('name') === name || el.dataset[DATA_LINE_ITEM_NAME] === name) {
        return el;
      }
    }
    return null;
  }

  function applyRequired(mainInp, stickInp) {
    const need =
      (mainInp.getAttribute('data-perso-required') || stickInp.getAttribute('data-perso-required')) === 'true';
    mainInp.removeAttribute('required');
    stickInp.removeAttribute('required');
    if (!need) {
      return;
    }
    if (mainInp.getAttribute('name')) {
      mainInp.setAttribute('required', 'required');
    }
  }

  function syncValues(fromRoot, toRoot) {
    for (const inp of qsa(fromRoot, 'input.product-personalization__input-field')) {
      if (inp.disabled) {
        continue;
      }
      const name = lineItemPropertyName(inp);
      if (!name) {
        continue;
      }
      const twin = findByLineItemName(toRoot, name);
      if (twin) {
        twin.value = inp.value;
      }
    }
  }

  function stripStickyLineItemNames(sticky) {
    for (const si of qsa(sticky, 'input.product-personalization__input-field')) {
      const n = si.getAttribute('name');
      if (n) {
        si.dataset[DATA_LINE_ITEM_NAME] = n;
        si.removeAttribute('name');
      }
    }
  }

  function setMode(main, sticky, desktop) {
    const mInputs = qsa(main, 'input.product-personalization__input-field');
    if (desktop) {
      for (const mi of mInputs) {
        const name = mi.getAttribute('name');
        if (!name) {
          continue;
        }
        const si = findByLineItemName(sticky, name);
        if (!si) {
          continue;
        }
        si.value = mi.value;
        mi.disabled = false;
        si.disabled = false;
      }
      stripStickyLineItemNames(sticky);
      for (const mi of mInputs) {
        const name = mi.getAttribute('name');
        if (!name) {
          continue;
        }
        const si = findByLineItemName(sticky, name);
        if (!si) {
          continue;
        }
        applyRequired(mi, si);
      }
      return;
    }
    for (const mi of mInputs) {
      const name = mi.getAttribute('name');
      if (!name) {
        continue;
      }
      const si = findByLineItemName(sticky, name);
      if (!si) {
        continue;
      }
      mi.value = si.value;
      si.disabled = true;
      mi.disabled = false;
      applyRequired(mi, si);
    }
  }

  function wirePair(main, sticky) {
    function onField(ev) {
      const t = ev.target;
      if (!t || !t.matches || !t.matches('input.product-personalization__input-field')) {
        return;
      }
      if (t.disabled) {
        return;
      }
      const name = lineItemPropertyName(t);
      if (!name) {
        return;
      }
      const inMain = main.contains(t);
      const twin = inMain ? findByLineItemName(sticky, name) : findByLineItemName(main, name);
      if (twin) {
        twin.value = t.value;
      }
    }
    main.addEventListener('input', onField);
    main.addEventListener('change', onField);
    sticky.addEventListener('input', onField);
    sticky.addEventListener('change', onField);
  }

  function init() {
    const main = document.querySelector('.product-personalization--main-handoff');
    const sticky = document.querySelector('.product-personalization--sticky');
    if (!main || !sticky) {
      return;
    }
    const mq = window.matchMedia(MQ);
    function apply() {
      setMode(main, sticky, mq.matches);
    }
    apply();
    wirePair(main, sticky);
    const onMq = function () {
      if (mq.matches) {
        syncValues(main, sticky);
        setMode(main, sticky, true);
      } else {
        syncValues(sticky, main);
        setMode(main, sticky, false);
      }
    };
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onMq);
    } else {
      mq.addListener(onMq);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
